const de = {
  translation: {
    //home
    home: "Startseite",
    vehicles: "Fahrzeuge",
    sign_in: "Anmelden",
    plan_you_trip: "Planen Sie Ihre Reise jetzt",
    save_big: "Sparen Sie viel mit unserer günstigen Autovermietung!",
    with_our_car: "mit unserer günstigen Autovermietung!",
    save_big_desc:
      "Mieten Sie das Auto Ihrer Träume. Unschlagbare Preise, unbegrenzte Kilometer, flexible Abholmöglichkeiten und vieles mehr.",
    book_ride: "Fahrt buchen",
    learn_more: "Mehr erfahren",
    book_a_car: "Auto mieten",
    without_driver: "Ohne Fahrer",
    with_driver: "Mit Fahrer",
    select_booking_type: "Buchungsart auswählen",
    self_drive: "Selbst fahren",
    tour: "Tour / Tagesmiete",
    transfer_service: "Transfer Service",
    pickup_date: "Abholdatum",
    dropoff_date: "Rückgabedatum",
    pickup_location: "Abholort",
    dropoff_location: "Rückgabeort",
    book_now: "Jetzt buchen",
    the_price_exclude: "Der Preis beinhaltet nicht die Gebühr des Fahrers, die zusätzlich berechnet wird",
    select_tour_package: "Tourpaket auswählen",
    select_duration: "Dauer auswählen",
    destination_location: "Zielort",
    quick_and_easy: "Schnelle und einfache Autovermietung",
    select_car: "Auto auswählen",
    we_offer:
      "Wir bieten eine große Auswahl an Fahrzeugen für alle Ihre Fahrbedürfnisse. Wir haben das perfekte Auto für Ihre Bedürfnisse",
    contact_operator: "Operator kontaktieren",
    our_knowlage:
      "Unsere sachkundigen und freundlichen Mitarbeiter stehen Ihnen jederzeit zur Verfügung, um alle Fragen oder Bedenken zu klären.",
    let_drive: "Lass uns fahren",
    whether_you: "Ob Sie die offene Straße erkunden, wir haben Sie mit unserer großen Auswahl an Autos abgedeckt",
    vehicle_models: "Fahrzeugmodelle",
    our_rental_fleet: "Unsere Mietflotte",
    choose_from:
      "Wählen Sie aus einer Vielzahl unserer erstaunlichen Fahrzeuge für Ihr nächstes Abenteuer oder Geschäftsreise.",
    reserve_now: "JETZT RESERVIEREN",
    save_big_bottom: "Sparen Sie viel mit unserer günstigen Autovermietung!",
    top_airport: "Top-Flughäfen. Lokale Anbieter. ",
    support: "Unterstützung",
    why_choose_use: "Warum Uns Wählen",
    best_valued: "Die besten Angebote, die Sie je finden werden",
    discover_the_best:
      "Entdecken Sie die besten Angebote, die Sie je finden werden, mit unseren unschlagbaren Angeboten. Wir sind bestrebt, Ihnen das beste Preis-Leistungs-Verhältnis zu bieten, damit Sie hochwertige Dienstleistungen und Produkte ohne Ihr Budget zu sprengen genießen können. Unsere Angebote sind darauf ausgelegt, Ihnen das ultimative Mietvergnügen zu bieten, also verpassen Sie nicht die Gelegenheit, viel zu sparen.",
    find_details: "Details finden",
    cross_city: "Cross City Drive",
    take_your_driving:
      "Heben Sie Ihr Fahrerlebnis auf die nächste Stufe mit unseren erstklassigen Fahrzeugen für Ihre Fernreiseabenteuer.",
    all_inclusive: "Alles inklusive Preisgestaltung",
    get_everything:
      "Erhalten Sie alles, was Sie in einem praktischen, transparenten Preis benötigen, mit unserer all-inclusive Preispolitik.",
    no_hidden: "Keine versteckten Gebühren",
    enjoy_peace:
      "Genießen Sie die Ruhe mit unserer Politik ohne versteckte Gebühren. Wir glauben an transparente und ehrliche Preisgestaltung.",
    review_by_people: "Bewertet von Menschen",
    client_testimonial: "Kundenbewertungen",
    client_testimonial_desc:
      "Erfahren Sie, welchen positiven Einfluss wir auf unsere Kunden hatten, indem Sie ihre Testimonials durchlesen. Unsere Kunden haben unsere Dienstleistungen und Ergebnisse erlebt, und sie sind bereit, ihre positiven Erfahrungen mit Ihnen zu teilen.",
    testi_aris:
      "Ich mag es wirklich. Der Service ist cool, der Fahrer kommt pünktlich an und kennt den Weg. Sehr glücklich, der Service ist wirklich cool. Das Auto auch. Riecht sauber und alles läuft reibungslos. Machen Sie Mas Yoyok (Fahrer) erfolgreich und gesund, dann ... Für einen Autovermieter möchte ich nichts anderes sagen. Weil es keine Beschwerden gab. Auf jeden Fall Erfolg.",
    testi_solomon:
      "Ich habe einen Avanza, Typ G, gemietet. Das Fahrzeug hatte keine Probleme, der Motor lief reibungslos, die Karosserie war ordentlich angemeldet, und das Wichtigste, als Sie das Fahrzeug gemietet haben, war das WA-Team/Gruppe sofort bereit ... für die angeforderten Dokumente... das ist cool. die Hauptsache ist.",
    faq: "FAQ",
    frequently_asked: "Häufig gestellte Fragen",
    frequently_asked_desc:
      "Häufig gestellte Fragen zum Buchungsprozess für die Autovermietung auf unserer Website: Antworten auf häufige Anliegen und Anfragen.",
    what_is_special: "1. Was ist das Besondere am Vergleich von Mietwagenangeboten?",
    what_is_special_desc:
      "Der Vergleich von Mietwagenangeboten ist wichtig, um das beste Angebot zu finden, das Ihrem Budget und Ihren Anforderungen entspricht und sicherzustellen, dass Sie das beste Preis-Leistungs-Verhältnis erhalten. Durch den Vergleich verschiedener Optionen können Sie Angebote finden, die niedrigere Preise, zusätzliche Dienstleistungen oder bessere Fahrzeugmodelle bieten. Sie können Mietwagenangebote finden, indem Sie online recherchieren und Preise von verschiedenen Mietwagenunternehmen vergleichen.",
    how_do_2: "2. Wie finde ich die Mietwagenangebote?",
    how_do_2_desc:
      "Sie können Mietwagenangebote finden, indem Sie online recherchieren und Preise von verschiedenen Mietwagenunternehmen vergleichen. Websites wie Expedia, Kayak und Travelocity ermöglichen es Ihnen, Preise zu vergleichen und verfügbare Mietfahrzeuge anzuzeigen. Es wird auch empfohlen, sich für E-Mail-Newsletter anzumelden und Mietwagenunternehmen in sozialen Medien zu folgen, um über besondere Angebote oder Aktionen informiert zu werden.",
    how_do_3: "3. Wie finde ich solch niedrige Mietwagenpreise?",
    how_do_3_desc:
      "Buchen Sie im Voraus: Das Buchen Ihres Mietfahrzeugs im Voraus kann oft zu niedrigeren Preisen führen. Vergleichen Sie die Preise mehrerer Unternehmen: Verwenden Sie Websites wie Kayak, Expedia oder Travelocity, um die Preise mehrerer Mietwagenunternehmen zu vergleichen. Suchen Sie nach Rabattcodes und Gutscheinen: Suchen Sie nach Rabattcodes und Gutscheinen, die Sie verwenden können, um den Mietpreis zu senken. Das Mieten von einem Standort außerhalb des Flughafens kann manchmal zu niedrigeren Preisen führen.",
    reservation_12: "Reservierungen müssen mindestens 12 Stunden im Voraus getätigt werden",
    reservation_24: "Reservierungen müssen mindestens 24 Stunden im Voraus getätigt werden",
    drop_after_pickup: "Das Rückgabedatum muss nach dem Abholdatum liegen",
    //car card
    daily_rate_from: "Tagespreis ab",
    includes: "Beinhaltet",
    isurances_etc: "VERSICHERUNGEN, KUNDENDIENST",
    more_info: "Mehr Info",
    efficient: "Effizient",
    safe: "Sicher",
    economical: "Sparen",
    //select vehicle
    book_car_by_getting: "Buchen Sie ein Auto, indem Sie mit uns in Kontakt treten",
    select_vehicle: "Fahrzeug auswählen",
    complete_reservation: "RESERVIERUNG VOLLSTÄNDIG",
    upon_completing: "Nach Abschluss dieser Reservierungsanfrage erhalten Sie:",
    your_rent_voucher:
      "Ihren Mietgutschein zur Vorlage bei der Abholung am Mietwagenschalter und eine gebührenfreie Kunden-Support-Nummer.",
    location_n_date: "Ort & Datum",
    car: "Auto",
    pickup_date_n_time: "Abholdatum & Uhrzeit",
    dropoff_date_n_time: "Rückgabedatum & Uhrzeit",
    prices: "Preise",
    additional_items: "Zusätzliche Artikel",
    umbrella: "Regenschirm",
    baby_seat: "Kindersitz",
    insurance: "Versicherung",
    full_covered: "Vollkaskoversicherung",
    wedding: "Hochzeitsauto",
    flower_arrangement: "Blumengesteck (Hochzeitsauto)",
    additional_stop: "Zusätzliche Halt",
    flower_bouquet: "Blumenstrauß",
    all_in_one_for: "Maut und Parken",
    price_estimate: "Preisangebot",
    estimate_total: "Geschätzter Gesamtpreis",
    the_price_does_not: "Der Preis beinhaltet nicht Mautgebühren, Parkgebühren, Trinkgeld.",
    the_price_includes: "Der Preis beinhaltet Benzin und einmaliges Parken",
    personal_info: "PERSÖNLICHE INFORMATIONEN",
    identity_type: "Identitätstyp",
    select_identity: "Identität auswählen",
    identity_image: "Identitätsbild",
    choose_file: "Datei auswählen",
    sim_or: "SIM / Führerschein",
    name: "Name",
    booker_name: "Bucher Name",
    enter_name: "Geben Sie Ihren Namen ein",
    enter_booker_name: "Geben Sie den Namen des Bestellers ein",
    whatsapp_number: "WhatsApp-Nummer",
    enter_whatsapp_number: "Geben Sie Ihre WhatsApp-Nummer ein",
    email: "E-Mail",
    enter_email: "Geben Sie Ihre E-Mail-Adresse ein",
    address: "Adresse",
    enter_address: "Geben Sie Ihre Adresse ein",
    emergency_contact_1: "Notfallkontakt 1",
    emergency_contact_2: "Notfallkontakt 2",
    enter_emergency: "Geben Sie Ihren Notfallkontakt ein",
    return_flight: "Rückflugreservierung",
    hotel_accomodation: "Hotel/Unterkunft während Ihres Aufenthalts",
    notes: "Hinweise",
    enter_notes: "Geben Sie Ihre Hinweise ein",
    we_will_ask: "Wir werden bei Bedarf zusätzliche Daten anfordern.",
    rental_policy: "Mietrichtlinie",
    in_town_usage: "Verwendung innerhalb der Stadt",
    add_outside_island: "Hinzufügen der Nutzung außerhalb der Insel",
    outside_island_usage: "Nutzung außerhalb der Insel",
    for_self_drive: "Nutzung außerhalb der Insel für Selbstfahren",
    denpasar_jimbaran_etc: "Denpasar, Jimbaran, Legian, Nusa Dua, Uluwatu, Ubud Center, Seminyak.",
    out_of_town_usage: "Verwendung außerhalb der Stadt",
    zone_1: "Zone 1",
    zone_2: "Zone 2",
    kerobokan_etc:
      "Bangli, Kintamani, Tabanan, Jatiluwih, Canggu, Pererenan, Gianyar (outside ubud center) (Gebühr je nach Fahrzeugtyp)",
    karangasem_etc: "Amed, Singaraja, Pelataran, Menjangan, Jembrana, Tulamben (Gebühr je nach Fahrzeugtyp)",
    this_rate_valid: "Dieser Tarif gilt nur für eine Richtung.",
    add_out_off_town: "Außerortsverwendung hinzufügen",
    select_date: "Datum auswählen",
    select_travel_date: "Wählen Sie ein Reisedatum außerhalb der Stadt",
    select_travel_date_island: "Wählen Sie ein Reisedatum außerhalb der Insel",
    total: "Gesamt",
    close: "Schließen",
    add: "Hinzufügen",
    loading: "Laden...",
    //customer form
    additional_information: "Zusätzliche Informationen (optional)",
    guest_name: "Gastname",
    driver_name: "Fahrername",
    passanger_total: "Passagieranzahl",
    luggage_total: "Gepäckanzahl",
    flight_detail: "Flugdetails",
    airline_name: "Beispiel: Fluggesellschaft: Garuda, Ankunftszeit: 17.00",
    hotel_detail: "Hotel/Unterkunftsdetails",
    hotel_name: "Beispiel: Hotelname: Indah Hotel",
    disability_needs: "Behinderungsbedarf",
    wheelchair: "Beispiel: Rollstuhl: 1",
    the_price_varies: "Der Preis variiert je nach Zielort.",
    including_petrol: "Inklusive Maut, Parken",
    change: "Änderung",
    setting_date_use: "Einstellung des Nutzungsdatums",
    date: "Datum",
    //detail vehicle
    detail_vehicle: "Fahrzeugdetails",
    price_type: "Preistyp",
    price: "Preis",
    area: "Bereich",
    yes: "Ja",
    trunk: "Kofferraum",
    customer_service: "KUNDENDIENST",
    insurances: "VERSICHERUNGEN",
    with_a_professional:
      "Mit einem professionellen und umfassenden Kundendienst können Sie beruhigt sein, dank der guten Unterstützung unseres Teams. Sie können auch von verschiedenen attraktiven Angeboten und Sonderaktionen profitieren, wenn Sie dieses Auto bestellen.",
    select_this_car: "Dieses Auto auswählen",
    //global
    save: "Speichern",
    big: "groß",
    days: "Tage",
    hour: "Stunde",
    brand: "Marke",
    year: "Jahr",
    seat: "Sitz",
    ac: "Klimaanlage",
    color: "Farbe",
    transmission: "Getriebe",
    fuel: "Kraftstoff",
    company: "Unternehmen",
    working_hour: "Arbeitsstunde",
    //privacy and policy
    privacy_and_police: "Geschäftsbedingungen",
    for_overtime:
      "Für Überstunden wird eine zusätzliche Gebühr von Rp 50.000/Stunde erhoben (Überstunden von mehr als 2 Stunden gelten als 1 Nutzungstag).",
    for_extension:
      "Für die Verlängerung der Miete mehr als 2 Mal überprüfen und bestätigen Sie bitte in unserem Büro, Wirasana Rent A Car Denpasar, Jl. Bypass Ngurah Rai Nr.162, Sanur Kaja, Süd-Denpasar.",
    unit_vehicles:
      "Mietfahrzeugeinheiten dürfen nicht an andere Personen als den Mieter, der den Mietvertrag unterschrieben hat, übertragen/benutzt werden (Wenn das Auto als Beweis verwendet wird, wird eine tägliche Mietgebühr berechnet).",
    reschedule_or:
      "Die Neuplanung oder Änderung des Standorts von Fahrzeugabholung/-rückgabe kann nicht bestätigt werden, wenn die Benachrichtigung weniger als 1x24 Stunden vor dem Buchungszeitplan erfolgt, um Fehler bei der operationellen Einstellung zu vermeiden.",
    reschedule_date:
      "Für die Neuplanung des Datums oder der Uhrzeit der Fahrzeugabholung/-rückgabe fällt eine Gebühr von Rp 75.000 an (maximal 2 Neuzeitplanungen erlaubt).",
    for_lose_umbrella:
      "Für den Verlust eines Regenschirms während der Mietdauer wird eine Gebühr von Rp 100.000 pro Regenschirm erhoben.",
    for_lose_baby_seat:
      "Für den Verlust eines Baby-Autositzes während der Mietdauer fällt eine Gebühr von Rp 2.000.000 pro Baby-Autositz an.",
    usage_unit: "Die Nutzungseinheit ist nur für das Gebiet Bali.",
    lose_stnk: "Für den Verlust von STNK (Fahrzeugregistrierung) fällt eine Gebühr von Rp 1.500.000 an.",
    lose_plat: "Für den Verlust von Nummernschildern fällt eine Gebühr von Rp 250.000 an.",
    for_damage_ban:
      "Für Reifenschäden aufgrund unsachgemäßer Verwendung/Verwendung außerhalb von Asphaltstraßen fällt eine Gebühr von Rp 700.000 pro Reifen an.",
    for_beret: "Bei neuen Kratzern wird eine Gebühr von Rp 750.000 pro Vorfall berechnet.",
    towing_fee:
      "Abschleppgebühren und Mietwagengebühren während der Reparatur sind nicht in der Selbstbeteiligung enthalten.",
    lack_of_petrol: "Ein Benzinmangel bei Abholung oder Rückgabe führt zu einer Gebühr von Rp 100.000 pro Box.",
    fuel_in_the_middle:
      "Wenn Ihnen während der Reise der Treibstoff ausgeht, fallen für Gebiete innerhalb der Stadt Bearbeitungsgebühren von Rp 250.000 an.",
    smell:
      "Wenn bei der Rückgabe des Fahrzeugs ein Geruch von Durian/Erbrochenem/Zigaretten/nassen Autositzen vorliegt, wird eine Gebühr von Rp. 1.500.000 erhoben.",
    dirty_car:
      "Für ein in sehr schmutzigem Zustand zurückgegebenes Auto fällt eine Reinigungsgebühr von Rp. 150.000 an.",
    lost_the_key: "Für den Verlust des Autoschlüssels wird eine Gebühr von Rp. 1.500.000 erhoben.",
    more_than_one_driver: "Wenn es mehr als einen Fahrer gibt, fällt eine Gebühr von Rp. 50.000/ID/Tag an.",
    please_not_park:
      "Bitte parken Sie das Fahrzeug nicht unter Bäumen oder an Orten, die die Position des Fahrzeugs gefährden können.",
    charging_error: "Im Falle eines Betankungsfehlers fällt eine Reparaturgebühr von Rp 2.500.000 an.",
    not_info:
      "Wenn wir keine Informationen bezüglich des Bedarfs an Fahrzeugreparaturhilfe während der Miete erhalten, akzeptieren wir keine Erstattung von Werkstätten ohne Genehmigung/Diskussion.",
    trouble_car:
      "Wenn es ein Problem mit dem Fahrzeug gibt, werden unsere Mechaniker versuchen, innerhalb von maximal 4 Stunden nach Ihrem Standort zu folgen und Ihnen zu helfen (abhängig von Ihrem Standort zu diesem Zeitpunkt).",
    security_deposit:
      "Eine Kaution von Rp 500.000 wird als Garantie während der Mietdauer einbehalten (Die Kaution wird innerhalb von maximal 7 Tagen nach Rückgabe des Fahrzeugs und nach E-Tilang-Überprüfung per Banküberweisung zurückerstattet).",
    basic_usage: "Die Grundnutzung ist auf das Stadtgebiet gemäß der Karte von Traveloka beschränkt.",
    excess_usage:
      "Übermäßige Nutzung über 12 Stunden oder nach Mitternacht führt zu zusätzlichen Gebühren gemäß Anhang/Regeln von Traveloka.",
    driver_contact: "Der Fahrer wird Sie kontaktieren, wenn er kurz davor ist, am Abholort anzukommen.",
    other_questions: "Wenn Sie weitere Fragen haben, können Sie uns gerne kontaktieren.",
    pickup_point:
      "Der Abholpunkt befindet sich vor Solaria. Wenn Sie einen anderen Abholpunkt wünschen, informieren Sie uns bitte direkt über diese Gruppe.",
    reschedule_info:
      "Die Neuplanung oder Änderungen der Abhol- und Zielorte können nicht bestätigt werden, wenn die Benachrichtigung weniger als 24 Stunden vor dem geplanten Buchungstermin erfolgt, um Fehler bei der operationellen Einrichtung zu vermeiden.",
    reschedule_fee: "Es fällt eine Gebühr von IDR 75.000 für eine Neuplanung an (maximal 2 Neuplanungen).",
    reschedule_airline:
      "Für Umbuchungen aufgrund von Flugplanänderungen legen Sie bitte einen Nachweis der Umbuchung vor, und wir werden dies ohne Gebühr bestätigen. Die Art des Fahrzeugs für die Abholung hängt jedoch von der Verfügbarkeit des Fahrzeugs zu der neu geplanten Zeit ab.",
    airline_delay:
      "Im Falle von Flugverspätungen legen Sie bitte einen Nachweis der Verspätung vor. Unser Fahrer wird sich bemühen, Sie gemäß dem neuesten Zeitplan abzuholen.",
    voucher_usage:
      "Der Gutschein ist gültig für eine einmalige Abholung ohne Zwischenstopps oder für eine Einwegabgabe.",
    additional_stop_meals:
      "Zusätzliche Stopps für Mahlzeiten usw. führen zu einer zusätzlichen Gebühr von IDR 100.000 pro Stunde.",
    driver_wait_time:
      "Der Fahrer wird bis zu 30 Minuten warten. Wenn die festgelegte Zeit überschritten wird, fällt eine zusätzliche Gebühr von IDR 100.000 pro Stunde an.",
    destination_change: "Für Änderungen des Ziels fallen zusätzliche Gebühren basierend auf dem Standort an.",
    no_eating_drinking: "Essen und Trinken, das zu Verschüttungen im Fahrzeug führen kann, ist nicht erlaubt.",
    boarding_landing: "Bitte bestätigen Sie, sobald Sie an Bord gegangen und am Flughafen Ngurah Rai gelandet sind.",
    driver_details: "Die Fahrerdetails werden am Tag der Reise bereitgestellt.",
    mask_and_distance: "Bitte tragen Sie immer eine Maske und halten Sie den sozialen Abstand im Fahrzeug ein.",
    disinfected_vehicles: "Alle Fahrzeuge von Wirasana wurden zuvor desinfiziert.",
    SWAB_driver_charge: "Zusätzliche Gebühr für den SWAB-Fahrer beträgt IDR 99.000 (wenn erforderlich).",
    passenger: "Passagier",
    use_the_current_location: "Verwenden Sie den aktuellen Standort",
    cancel: "Abbrechen",
    confirm: "Bestätigen",
    i_have_read_and_accept: "Ich habe die Datenschutzrichtlinie gelesen und akzeptiere sie",
    i_accept_the_privacy: "Ich akzeptiere die Datenschutzrichtlinie",
    open_filters: "Filter öffnen",
    sort: "Sortieren",
    price_low_to_high: "Preis: Aufsteigend",
    price_high_to_low: "Preis: Absteigend",
    name_a_z: "Name: A → Z",
    name_z_a: "Name: Z → A",
    filters: "Filter",
    price_per_day: "Preis pro Tag",
    total_passenger: "Gesamtanzahl Passagiere",
    drivetrain: "Antriebsstrang",
    clear_all: "Alles löschen",
    apply_filters: "Filter anwenden",
    search_car: "Auto suchen",
    ready_to_continue_payment: "Bereit, mit der Zahlung fortzufahren?",
    please_review_payment: "Bitte überprüfen Sie Ihre Zahlungsdetails, bevor Sie fortfahren.",
    total_amount: "Zu zahlender Gesamtbetrag",
    proceed_to_payment: "Weiter zur Zahlung",
    about: "Über uns",
    about_company: "Über das Unternehmen",
    about_headline: "Starten Sie den Motor und Ihr Abenteuer beginnt",
    about_description:
      "Einfach, aber engagiert, bieten wir den besten Service. Wir sorgen dafür, dass jede Reise komfortabel, sicher und unvergesslich ist.",
    about_car_types: "Fahrzeugtypen",
    about_rental_outlets: "Mietstationen",
    about_repair_shop: "Werkstätten",
    about_book_car: "Buchen Sie ein Auto, indem Sie uns kontaktieren",
    about_phone: "(0361) 286-066",
    language: "Sprache",
    about_us: "Über uns",
    contact_us: "Kontakt",
    booking_type: "Buchungstyp",
    the_royal_essence: "Die königliche Essenz der Reise",
    relaxed_journey: "ENTSPANNTESTE REISE ÜBERHAUPT",
    page_title: "Kontakt",
    headline: "Benötigen Sie weitere Informationen?",
    description: "Ein vielseitiger Profi mit Erfahrung in Forschung, Entwicklung und Lehre. Über 15 Jahre Erfahrung.",
    phone_label: "Telefon",
    email_label: "E-Mail",
    address_label: "Adresse",
    form_name: "Vollständiger Name",
    form_message: "Erzählen Sie uns davon",
    form_placeholder_name: "Z.B.: 'Hans Müller'",
    form_placeholder_message: "Hier schreiben...",
    form_button: "Über WhatsApp senden",
    required_alert: "Bitte füllen Sie alle Pflichtfelder aus!",
    address_value: "Denpasar, Bali",
    why_choose_wirasana: "Warum Wirasana wählen",
    trusted_partner: "Ihr vertrauenswürdiger Partner für Autovermietung auf Bali",
    experience_excellence:
      "Erleben Sie Exzellenz mit unserer Premiumflotte, außergewöhnlichem Service und unschlagbaren Preisen.",
    happy_customers: "Zufriedene Kunden",
    vehicles_available: "Verfügbare Fahrzeuge",
    years_experience: "Jahre Erfahrung",
    satisfaction_rate: "Zufriedenheitsrate",
    what_makes_us_different: "Was uns unterscheidet",
    discover_advantages: "Entdecken Sie die Vorteile, die uns von der Konkurrenz abheben",
    comprehensive_insurance: "Umfassende Versicherung",
    comprehensive_insurance_desc: "Vollkaskoversicherung bei jeder Miete inklusive. Fahren Sie sorgenfrei.",
    premium_fleet: "Premiumflotte",
    premium_fleet_desc: "Gut gewartete, moderne Fahrzeuge für das beste Fahrerlebnis.",
    support_247: "24/7 Support",
    support_247_desc: "Kundendienst rund um die Uhr für Sie da.",
    best_price: "Bestpreisgarantie",
    best_price_desc: "Transparente Preise, keine versteckten Gebühren.",
    flexible_rental: "Flexible Vermietung",
    flexible_rental_desc: "Stunden-, Tages- oder Monatsmiete – ganz nach Ihrem Zeitplan.",
    free_delivery: "Kostenlose Lieferung",
    free_delivery_desc: "Kostenlose Fahrzeugzustellung und -abholung an Ihrem Standort auf Bali.",
    more_reasons: "Weitere Gründe, uns zu vertrauen",
    trusted_by_thousands: "Von Tausenden vertraut",
    trusted_by_thousands_desc: "Über 10.000 zufriedene Kunden haben uns auf Bali gewählt.",
    licensed_insured: "Lizenziert & Versichert",
    licensed_insured_desc: "Vollständig lizenziert und versichert für Ihre Sicherheit.",
    easy_booking: "Einfache Buchung",
    easy_booking_desc: "Buchen Sie online in wenigen Minuten ohne Papierkram.",
    flexible_payment: "Flexible Zahlungsmethoden",
    flexible_payment_desc: "Kreditkarten, Überweisungen und digitale Wallets werden akzeptiert.",
    cta_title: "Bereit für Ihre Reise?",
    cta_desc: "Buchen Sie jetzt Ihr perfektes Fahrzeug und erleben Sie den Unterschied mit Wirasana.",
    call_us_now: "Rufen Sie uns jetzt an",
    back: "Zurück",
    weather_protection: "Wetterschutz für Outdoor-Aktivitäten",
    safety_seat_children: "Kindersitz für Kinder (5–4 Jahre)",
    beautiful_flower_arrangements: "Schöne Blumenarrangements für besondere Anlässe",
    extra_stops: "Zusätzliche Stopps während Ihrer Reise",
    all_in_one_package: "Alles-in-einem-Paket für Bequemlichkeit",
    fresh_flower_bouquet: "Frisches Blumenstrauß-Arrangement",
    set_quantity_each_date: "Menge für jedes Datum festlegen",
    total_items: "Gesamtartikel",
    items: "Artikel",
    select_all: "Alle auswählen",
    select_dates_apply_item: "Wählen Sie die Daten aus, für die Sie diesen Artikel anwenden möchten",
    item_will_be_applied: "Artikel wird angewendet",
    out_of: "von",
    total_day: "Gesamttage",
    type_or_choose_location: "Geben Sie einen Ort ein oder wählen Sie aus der Liste...",
    select_from_map: "Standort auf der Karte auswählen",
    popular_locations: "Beliebte Orte",
    manual_input_hint: "Oder geben Sie den Ort manuell in das Suchfeld ein",
    common: {
      back: "Zurück",
      back_to_search: "Zurück zur Suche",
      name: "Name",
      email: "E-Mail",
      phone: "Telefon",
      total: "Gesamt",
      hours: "Std",
      processing: "Verarbeitung...",
      searching: "Suche...",
      error_occurred: "Es ist ein Fehler aufgetreten. ",
      information: "Information",
    },
    booking: {
      detail: "Buchungsdetails",
      booking_number: "Buchungsnummer{{number}}",
      not_found: "Daten nicht gefunden",
      search_again: "Bitte suchen Sie erneut nach Ihrer Buchung",
      type: "Buchungstyp",
      pickup_date: "Abholdatum",
      dropoff_date: "Abgabedatum",
      price_breakdown: "Preisaufschlüsselung",
      price_date: "Preis ({{date}})",
      fees: "Transaktionsgebühren und Steuern",
      delivery_fee: "Liefergebühr",
      pickup_fee: "Abholgebühr",
      canceled: "Bestellung storniert",
      contact_customer_service: "Diese Bestellung wurde storniert. ",
      check_history: "Überprüfen Sie den Buchungsverlauf",
      enter_details: "Geben Sie Ihre E-Mail-Adresse und Ihren Buchungscode ein, um Ihre Bestelldetails anzuzeigen",
      booking_code: "Buchungscode",
      code_example: "Beispiel: S-0018, T-0025 (verwenden Sie S-0018 für Demo)",
      check_booking: "ÜBERPRÜFEN SIE DIE BUCHUNG",
      info_code_sent: "Der Buchungscode wird nach der Buchung an Ihre E-Mail gesendet",
      info_continue_payment: "Sie können die Zahlung für unbezahlte Bestellungen fortsetzen",
      info_contact_support: "Wenden Sie sich an den Kundendienst, wenn Probleme auftreten",
    },
    status: {
      booked: "Gebucht",
      prepared: "Vorbereitet",
      operated: "Betrieben",
      canceled: "Abgesagt",
      success: "Erfolg",
    },
    payment: {
      not_paid: "Nicht bezahlt",
      paid: "Bezahlt",
      partial: "Teilzahlung",
      continue: "WEITERZAHLUNG",
      invoice_not_found: "Rechnung nicht gefunden",
      link_failed: "Zahlungslink konnte nicht erstellt werden. ",
      received: "Zahlung erhalten",
      total_paid: "Gesamtbezahlt: {{amount}}",
    },
    validation: {
      fill_all_fields: "Bitte geben Sie E-Mail und Buchungscode ein",
    },
    manage_booking: "Buchung verwalten",
    booking_confirmation: "Buchungsbestätigung",
    next: "Nächste",
    booking_details: "Buchungsdetails",
    review_n_confirm: "Überprüfen und bestätigen",
    booking_success: "Buchung erfolgreich!",
    booking_success_message: "Ihre Buchung wurde erfolgreich übermittelt. ",
    open_payment_link: "Zahlungslink öffnen",
    required_documents: "Erforderliche Dokumente",
    payment_information: "Zahlungsinformationen",
    review_payment_details: "Bitte überprüfen Sie Ihre Zahlungsdetails und fahren Sie mit der Zahlung fort",
    booking_summary: "Buchungsübersicht",
    invoice_number: "Rechnungsnummer",
    customer_name: "Kundenname",
    payment_instructions: "Zahlungsanweisungen",
    payment_instruction_1: "Klicken Sie auf die Schaltfläche unten, um eine Zahlungsrechnung zu erstellen",
    payment_instruction_2: "Sie werden zur Xendit-Zahlungsseite weitergeleitet",
    payment_instruction_3: "Schließen Sie Ihre Zahlung mit den verfügbaren Zahlungsmethoden ab",
    payment_instruction_4: "Nach erfolgreicher Zahlung erhalten Sie eine Bestätigungs-E-Mail",
    payment_link_created: "Zahlungslink wurde erstellt!",
    click_below_to_proceed: "Klicken Sie auf die Schaltfläche unten, um mit der Zahlung fortzufahren",
    creating_invoice: "Rechnung erstellen...",
    create_payment_invoice: "Zahlungsrechnung erstellen",
    done: "Ich habe die Zahlung abgeschlossen",
    order_summary: "Bestellübersicht",
    please_review_order: "Bitte überprüfen Sie Ihre Bestelldaten, bevor Sie mit der Zahlung fortfahren",
    customer_information: "Kundeninformationen",
    phone: "Telefon",
    vehicle: "Fahrzeug",
    rental_period: "Mietzeitraum",
    locations: "Standorte",
    price_breakdown: "Preisübersicht",
    base_price: "Grundpreis",
    delivery_fee: "Liefergebühr",
    pickup_fee: "Abholgebühr",
    tour_package: "Tourpaketpreise beginnen bei",
    airport_transfer_from: "Preise für den Flughafentransfer beginnen bei",
    tourPackage: "Reisepaket",
    basic_title: "Grundschutz",
    basic_subtitle: "Der Grundschutz ist in Ihrer Miete enthalten",
    km_unlimited: "Unbegrenzte Kilometerzahl",
    own_risk: "Mit einer Selbstrisikogebühr von 750.000 Rp pro Vorfall",
    damage_cover: "Deckung für Kollisionen, Kratzer und Aufprallschäden",
    glass_tire: "Reifen- und Glasschutz",
    interior_protect: "Innenschutz",
    not_included_towing: "Ohne Abschleppdienst und zusätzliche Miettage, wenn die Reparatur länger als 7 Tage dauert",
    got_it: "Habe es",
    basic_protection: "Grundschutz",
    see_more_details: "Weitere Details anzeigen",
    gps: "GPS",
    gps_desc: "Navigationssystem im Fahrzeug.",
    phone_holder: "Telefonhalter",
    phone_holder_desc: "Freihändige Halterung für sicheres Fahren.",
    family_card: "Familienkarte",
    business_id: "Geschäfts-ID",
    social_media: "Soziale Medien",
    customer_info: "Kundeninformationen",
    enter_social_media: "Soziale Medien eingeben",
    insurance_subtitle: "Schützen Sie Ihre Reise mit umfassendem Versicherungsschutz und Sorgenfreiheit",
    included: "Im Lieferumfang enthalten",
    not_included: "Nicht im Lieferumfang enthalten",
    toll_and_parking: "Maut und Parken",
    toll_and_parking_desc: "Maut- und Parkkosten",
    your_trusted_mobility: "Ihr vertrauenswürdiger Mobilitätspartner auf Bali",
    wirasana_is_professional:
      "Wirasana Rent A Car ist ein professioneller Autovermieter mit Sitz auf Bali, der sich der Bereitstellung zuverlässiger, komfortabler und flexibler Transportlösungen für Reisende und Unternehmen widmet. Mit jahrelanger Erfahrung in der Transportbranche verstehen wir, dass Mobilität ein wesentlicher Bestandteil jeder Reise ist – ob für Freizeit, Geschäft oder besondere Anlässe.",
    our_mission_is_to_make:
      "Unsere Mission ist es, den Transport auf Bali einfach, sicher und zugänglich zu machen. Wir bieten eine breite Palette gut gewarteter Fahrzeuge an, die verschiedenen Bedürfnissen gerecht werden, von Kleinwagen für Privatfahrten bis hin zu Premiumfahrzeugen für Geschäftsreisen und besondere Veranstaltungen.",
    lets_get_you: "Bringen wir Sie auf die Straße",
    have_questions_about:
      "Haben Sie Fragen zu unseren Fahrzeugen, Preisen oder der Verfügbarkeit? Unser Team steht bereit, um Ihnen zu helfen. Ob Sie einen Urlaub auf Bali, eine Geschäftsreise oder eine besondere Veranstaltung planen, wir sind hier, um Ihre Transporterfahrung reibungslos und sorgenfrei zu gestalten.",
    search_vehicle: "Fahrzeug suchen",
    vehicle_type: "Fahrzeugtyp",
    motorcycle: "Motorrad",
    all: "Alle",
    your_trustedcar_rental_in_bali: "Ihr zuverlässiger Autovermieter auf Bali",
    simple_booking: "Einfache Buchung. Zuverlässige Fahrzeuge. Hervorragender Service.",
    we_provide_flexible:
      "Wir bieten flexible Mietlösungen, einschließlich Selbstfahrer, Fahrerservice und Flughafentransfers, die alle darauf ausgelegt sind, Ihre Reise nach Bali mühelos zu gestalten.",
  },
};

export default de;
